exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-34bb9aea]{margin:.2rem;text-indent:2em}.btn[data-v-34bb9aea]{color:#fff;background:#d8d8d8;height:.9rem;line-height:.9rem;margin:.4rem .2rem;border-radius:.04rem}.active[data-v-34bb9aea]{background:#0047ba}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34bb9aea","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/regProtocol/regProtocol.vue
// module id = 382
// module chunks = 0